// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * GDS API Internal
 * <!-- used by swagger --> An Internal API to manage Aura Graph Analytics Sessions. Intended to be used by other components inside Aura. These endpoints require mtls and are not exposed to the public.
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalendpointsListModelsResponse } from './InternalendpointsListModelsResponse';
import {
  InternalendpointsListModelsResponseFromJSON,
  InternalendpointsListModelsResponseFromJSONTyped,
  InternalendpointsListModelsResponseToJSON,
  InternalendpointsListModelsResponseToJSONTyped,
} from './InternalendpointsListModelsResponse';
import type { EndpointsError } from './EndpointsError';
import {
  EndpointsErrorFromJSON,
  EndpointsErrorFromJSONTyped,
  EndpointsErrorToJSON,
  EndpointsErrorToJSONTyped,
} from './EndpointsError';

/**
 *
 * @export
 * @interface InternalModelsGet200Response
 */
export interface InternalModelsGet200Response {
  /**
   *
   * @type {InternalendpointsListModelsResponse}
   * @memberof InternalModelsGet200Response
   */
  data?: InternalendpointsListModelsResponse;
  /**
   *
   * @type {Array<EndpointsError>}
   * @memberof InternalModelsGet200Response
   */
  errors?: Array<EndpointsError>;
}

/**
 * Check if a given object implements the InternalModelsGet200Response interface.
 */
export function instanceOfInternalModelsGet200Response(
  value: object,
): value is InternalModelsGet200Response {
  return true;
}

export function InternalModelsGet200ResponseFromJSON(
  json: any,
): InternalModelsGet200Response {
  return InternalModelsGet200ResponseFromJSONTyped(json, false);
}

export function InternalModelsGet200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InternalModelsGet200Response {
  if (json == null) {
    return json;
  }
  return {
    data:
      json['data'] == null
        ? undefined
        : InternalendpointsListModelsResponseFromJSON(json['data']),
    errors:
      json['errors'] == null
        ? undefined
        : (json['errors'] as Array<any>).map(EndpointsErrorFromJSON),
  };
}

export function InternalModelsGet200ResponseToJSON(
  json: any,
): InternalModelsGet200Response {
  return InternalModelsGet200ResponseToJSONTyped(json, false);
}

export function InternalModelsGet200ResponseToJSONTyped(
  value?: InternalModelsGet200Response | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    data: InternalendpointsListModelsResponseToJSON(value['data']),
    errors:
      value['errors'] == null
        ? undefined
        : (value['errors'] as Array<any>).map(EndpointsErrorToJSON),
  };
}
